import styled from "styled-components";

const ImageThumbs = styled.div`
    top: 0;
    left: 0;
    box-sizing: border-box;
    margin-bottom: 15px;
    > a {
        min-height: 100px;
        cursor: pointer;
        border: 2px solid #ececec;
        &:hover,
        &.active {
            // opacity: 0.7;
            border-color: #333;
        }
        &.active {
            pointer-events: none;
        }

        &:not(.loaded),
        &.loading {
            background-color: #efefef;
            > img {
                opacity: 0;
            }
        }
    }
`;
export default ImageThumbs;
